import { createBrowserRouter, Navigate } from 'react-router-dom';

import { RotaProtegida } from './RotaProtegida';
import { paginaSobDemanda } from './pagina-sob-demanda';

const LayoutPrincipal = paginaSobDemanda(async () => ({ default: (await import('@/components/layout/LayoutPrincipal')).LayoutPrincipal }));
const Login = paginaSobDemanda(async () => ({ default: (await import('@/paginas/autenticacao/Login')).Login }));
const EsqueciSenha = paginaSobDemanda(async () => ({ default: (await import('@/paginas/autenticacao/EsqueciSenha')).default }));
const VerificarCodigo = paginaSobDemanda(async () => ({ default: (await import('@/paginas/autenticacao/VerificarCodigo')).default }));
const RedefinirSenha = paginaSobDemanda(async () => ({ default: (await import('@/paginas/autenticacao/RedefinirSenha')).default }));
const TrocarSenha = paginaSobDemanda(async () => ({ default: (await import('@/paginas/autenticacao/TrocarSenha')).TrocarSenha }));
const SemPermissao = paginaSobDemanda(async () => ({ default: (await import('@/paginas/comum/SemPermissao')).default }));
const NaoEncontrado = paginaSobDemanda(async () => ({ default: (await import('@/paginas/comum/NaoEncontrado')).default }));
const Dashboard = paginaSobDemanda(async () => ({ default: (await import('@/paginas/dashboard/Dashboard')).Dashboard }));
const UsuariosLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/usuarios')).UsuariosLista }));
const UsuarioRedirect = paginaSobDemanda(async () => ({ default: (await import('@/paginas/usuarios')).UsuarioRedirect }));
const RegionaisLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/regionais')).RegionaisLista }));
const RegionalFormulario = paginaSobDemanda(async () => ({ default: (await import('@/paginas/regionais')).RegionalFormulario }));
const EscolasLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/escolas')).EscolasLista }));
const EscolaFormulario = paginaSobDemanda(async () => ({ default: (await import('@/paginas/escolas')).EscolaFormulario }));
const SecretariasLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/secretarias')).SecretariasLista }));
const SecretariaFormulario = paginaSobDemanda(async () => ({ default: (await import('@/paginas/secretarias')).SecretariaFormulario }));
const PessoasLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/pessoas')).PessoasLista }));
const PessoaFormulario = paginaSobDemanda(async () => ({ default: (await import('@/paginas/pessoas')).PessoaFormulario }));
const MatricularAlunoWizard = paginaSobDemanda(async () => ({ default: (await import('@/paginas/pessoas')).MatricularAlunoWizard }));
const VinculosLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/vinculos')).VinculosLista }));
const DisciplinasLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/disciplinas')).DisciplinasLista }));
const AnosLetivosLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/anos-letivos')).AnosLetivosLista }));
const AnoLetivoDetalhe = paginaSobDemanda(async () => ({ default: (await import('@/paginas/anos-letivos')).AnoLetivoDetalhe }));
const BNCCConsulta = paginaSobDemanda(async () => ({ default: (await import('@/paginas/bncc')).BNCCConsulta }));
const TurmasLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/turmas')).TurmasLista }));
const TurmaDetalhe = paginaSobDemanda(async () => ({ default: (await import('@/paginas/turmas')).TurmaDetalhe }));
const AlunoEnturmadoDetalhe = paginaSobDemanda(async () => ({ default: (await import('@/paginas/turmas')).AlunoEnturmadoDetalhe }));
const ComunicadosLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/comunicados')).ComunicadosLista }));
const TransferenciasLista = paginaSobDemanda(async () => ({ default: (await import('@/paginas/transferencias')).TransferenciasLista }));
const PainelLayout = paginaSobDemanda(async () => ({ default: (await import('@/paginas/painel/PainelLayout')).PainelLayout }));
const RotaDesempenho = paginaSobDemanda(async () => ({ default: (await import('@/paginas/painel/PainelLayout')).RotaDesempenho }));
const RotaHorario = paginaSobDemanda(async () => ({ default: (await import('@/paginas/painel/PainelLayout')).RotaHorario }));
const RotaComunicados = paginaSobDemanda(async () => ({ default: (await import('@/paginas/painel/PainelLayout')).RotaComunicados }));
const RotaBoletim = paginaSobDemanda(async () => ({ default: (await import('@/paginas/painel/PainelLayout')).RotaBoletim }));
const RotaObservacoes = paginaSobDemanda(async () => ({ default: (await import('@/paginas/painel/PainelLayout')).RotaObservacoes }));
const MinhasTurmas = paginaSobDemanda(async () => ({ default: (await import('@/paginas/academico')).MinhasTurmas }));
const AvaliacoesTurma = paginaSobDemanda(async () => ({ default: (await import('@/paginas/academico')).AvaliacoesTurma }));
const LancamentoNotas = paginaSobDemanda(async () => ({ default: (await import('@/paginas/academico')).LancamentoNotas }));
const FrequenciaTurma = paginaSobDemanda(async () => ({ default: (await import('@/paginas/academico')).FrequenciaTurma }));
const PerfilPage = paginaSobDemanda(async () => ({ default: (await import('@/paginas/perfil/PerfilPage')).PerfilPage }));

export const router = createBrowserRouter([
  // Rotas públicas
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/esqueci-senha',
    element: <EsqueciSenha />,
  },
  {
    path: '/verificar-codigo',
    element: <VerificarCodigo />,
  },
  {
    path: '/redefinir-senha',
    element: <RedefinirSenha />,
  },
  {
    path: '/sem-permissao',
    element: <SemPermissao />,
  },

  // Rotas protegidas
  {
    path: '/',
    element: (
      <RotaProtegida>
        <LayoutPrincipal />
      </RotaProtegida>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'secretarias',
        element: <SecretariasLista />,
      },
      {
        path: 'secretarias/novo',
        element: <SecretariaFormulario />,
      },
      {
        path: 'secretarias/:id',
        element: <SecretariaFormulario />,
      },
      {
        path: 'regionais',
        element: <RegionaisLista />,
      },
      {
        path: 'regionais/novo',
        element: <RegionalFormulario />,
      },
      {
        path: 'regionais/:id',
        element: <RegionalFormulario />,
      },
      {
        path: 'escolas',
        element: <EscolasLista />,
      },
      {
        path: 'escolas/novo',
        element: <EscolaFormulario />,
      },
      {
        path: 'escolas/:id',
        element: <EscolaFormulario />,
      },
      {
        path: 'pessoas',
        element: <PessoasLista />,
      },
      {
        path: 'pessoas/novo',
        element: <PessoaFormulario />,
      },
      {
        path: 'pessoas/matricular-aluno',
        element: <MatricularAlunoWizard />,
      },
      {
        path: 'pessoas/:id',
        element: <PessoaFormulario />,
      },
      {
        path: 'vinculos',
        element: <VinculosLista />,
      },
      {
        path: 'disciplinas',
        element: <DisciplinasLista />,
      },
      {
        path: 'anos-letivos',
        element: <AnosLetivosLista />,
      },
      {
        path: 'anos-letivos/:id',
        element: <AnoLetivoDetalhe />,
      },
      {
        path: 'bncc/habilidades',
        element: <BNCCConsulta />,
      },
      {
        path: 'usuarios',
        element: <UsuariosLista />,
      },
      {
        path: 'usuarios/novo',
        // Fluxo unificado: cria pessoa primeiro, depois conta (Sprint D)
        element: <Navigate to="/pessoas/novo" replace />,
      },
      {
        path: 'usuarios/:id',
        // Tela standalone removida (spec D3). Resolve pessoa_id e redireciona
        // para o fluxo unificado em /pessoas/:pessoaId?aba=conta.
        element: <UsuarioRedirect />,
      },
      {
        path: 'turmas',
        element: <TurmasLista />,
      },
      {
        path: 'turmas/:id',
        element: <TurmaDetalhe />,
      },
      {
        path: 'turmas/:id/alunos/:matriculaId',
        element: <AlunoEnturmadoDetalhe />,
      },
      {
        path: 'comunicados',
        element: <ComunicadosLista />,
      },
      {
        // Sem isto, quem não tem a permissão (ex.: professor) alcança a tela
        // digitando a URL: o menu só esconde o item. A API nega os dados, mas
        // a pessoa cai numa fila vazia em vez de "sem permissão".
        path: 'transferencias',
        element: (
          <RotaProtegida permissoes={['transferencia:listar']}>
            <TransferenciasLista />
          </RotaProtegida>
        ),
      },
      {
        path: 'painel',
        element: <PainelLayout />,
        children: [
          { index: true, element: <RotaDesempenho /> },
          { path: 'boletim', element: <RotaBoletim /> },
          { path: 'horario', element: <RotaHorario /> },
          { path: 'comunicados', element: <RotaComunicados /> },
          { path: 'observacoes', element: <RotaObservacoes /> },
        ],
      },
      {
        // Hub do professor: Minhas Turmas → Avaliações/Notas ou Diário.
        path: 'academico/notas',
        element: <MinhasTurmas />,
      },
      {
        // Mesmo hub, acessado pelo menu "Frequência".
        path: 'academico/frequencia',
        element: <MinhasTurmas />,
      },
      {
        path: 'academico/turmas/:turmaDisciplinaId/avaliacoes',
        element: <AvaliacoesTurma />,
      },
      {
        path: 'academico/turmas/:turmaDisciplinaId/frequencia',
        element: <FrequenciaTurma />,
      },
      {
        path: 'academico/avaliacoes/:avaliacaoId/notas',
        element: <LancamentoNotas />,
      },
      {
        path: 'academico/*',
        element: <div>Módulo Acadêmico (em desenvolvimento)</div>,
      },
      {
        path: 'configuracoes',
        element: <div>Página de Configurações (em desenvolvimento)</div>,
      },
      {
        path: 'perfil',
        element: <PerfilPage />,
      },
      {
        path: 'sem-permissao',
        element: <SemPermissao />,
      },
    ],
  },

  // Troca de senha obrigatória (primeiro acesso): apenas autenticação,
  // sem layout/menu/perfil, para ser alcançável por qualquer usuário
  // autenticado, inclusive aluno sem vínculo.
  {
    path: '/trocar-senha',
    element: (
      <RotaProtegida>
        <TrocarSenha />
      </RotaProtegida>
    ),
  },

  // 404
  {
    path: '*',
    element: <NaoEncontrado />,
  },
]);
